import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { isValidElement, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@ibk/shared-translation';
import { CardCarousel, HomeBanners, Icon, ProductBanners, ProductsList, } from '../index';
import { PaymentCard } from '../PaymentCard';
import styles from './AppHome.module.css';
import { useAppHome } from './hooks';
const getFirstName = (fullName) => {
    if (!fullName || typeof fullName !== 'string') {
        return '';
    }
    return fullName.trim().split(' ')[0];
};
export const AppHome = ({ products, carouselItems, banners, domain, homeProducts, userName = '', dateInfo, bannersTitle = '', className = '', onLoyaltyProgramCardClick, pendingActionCard, }) => {
    const { t } = useTranslation();
    const firstName = getFirstName(userName);
    const navigate = useNavigate();
    const { hasApprovalPermissions, isLoading: isLoadingPayments, paymentsCount } = useAppHome();
    const approvePaymentsCard = useMemo(() => hasApprovalPermissions && paymentsCount > 0 ? (_jsx(PaymentCard, { title: 'Aprovar pagamentos', icon: _jsx(Icon, { name: 'digitalAccountFilled' }), id: 'id', onClick: () => navigate('/conta-pj/aprovar-pagamentos'), "data-testid": 'approve-payments-card', isLoading: isLoadingPayments, paymentsCount: paymentsCount })) : null, [hasApprovalPermissions, paymentsCount, isLoadingPayments, navigate]);
    const pendingActionSlides = useMemo(() => {
        const slides = [];
        if (pendingActionCard) {
            slides.push({ id: 'pending-action', content: pendingActionCard });
        }
        if (approvePaymentsCard) {
            slides.push({ id: 'approve-payments', content: approvePaymentsCard });
        }
        return slides;
    }, [pendingActionCard, approvePaymentsCard]);
    const handleProductClick = (id) => {
        switch (id) {
            case 'escritorio-contabilidade-digital':
            case 'empresa-contabilidade-digital':
                navigate('/contabilidade-digital');
                break;
            case 'escritorio-conta-pj':
            case 'empresa-conta-pj':
                navigate('/conta-pj');
                break;
            case 'escritorio-beneficios':
            case 'empresa-beneficios':
                navigate('/beneficios');
                break;
            case 'escritorio-programa-fidelidade':
                onLoyaltyProgramCardClick?.();
                navigate('/dominio-recompensas');
                break;
            case 'escritorio-cobrancas':
            case 'empresa-cobrancas':
                navigate('/cobrancas');
                break;
            default:
                break;
        }
    };
    const renderBannersContent = () => {
        if (banners && domain && homeProducts) {
            return (_jsx(ProductBanners, { title: bannersTitle, banners: banners, context: { domain }, homeProducts: homeProducts, "data-testid": 'home-product-banners' }));
        }
        if (carouselItems) {
            if (isValidElement(carouselItems)) {
                return (_jsxs("div", { "data-testid": 'home-custom-banners', children: [bannersTitle && _jsx("h2", { className: styles.bannersTitle, children: bannersTitle }), carouselItems] }));
            }
            return _jsx(HomeBanners, { title: bannersTitle, items: carouselItems });
        }
        return null;
    };
    return (_jsx("div", { className: `${styles.container} ${className}`, "data-testid": 'home-container', children: _jsxs("div", { className: styles.content, "data-testid": 'home-content', children: [_jsxs("section", { className: styles.welcomeSection, "data-testid": 'home-welcome-section', children: [_jsx("h1", { className: styles.greeting, "data-testid": 'home-greeting', children: t('home.greeting', { userName: firstName }) }), _jsx("p", { className: styles.date, "data-testid": 'home-date', children: t('home.date', {
                                dayOfWeek: dateInfo.weekday,
                                day: dateInfo.day,
                                month: dateInfo.month,
                                year: dateInfo.year,
                            }) })] }), pendingActionSlides.length > 0 ? (_jsx("section", { className: styles.pendingActionSection, "data-testid": 'home-pending-action', children: _jsx(CardCarousel, { slides: pendingActionSlides, "data-testid": 'home-pending-action-carousel' }) })) : null, _jsx("div", { className: styles.divider, "data-testid": 'home-divider' }), _jsx("section", { className: styles.productsSection, "data-testid": 'home-products', children: _jsx(ProductsList, { products: products, onProductClick: handleProductClick, "data-testid": 'home-products-list' }) }), _jsx("section", { className: styles.bannersSection, "data-testid": 'home-banners', children: renderBannersContent() })] }) }));
};
